module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('altmetric-stats-bar')], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "keywords"
  }, [_c('em', [_vm._v(_vm._s(_vm.keywordsFormatted))])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Article Tools\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block",
    on: {
      "click": function($event) {
        _vm.getPdf()
      }
    }
  }, [_vm._v("Download PDF")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('sidebar-signup-button')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block"
  }, [_vm._v("How to Cite")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block"
  }, [_vm._v("Order a Reprint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-12 col-xl-6 mb-2"
  }, [_c('button', {
    staticClass: "button-primary btn-block"
  }, [_vm._v("Supplementals")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50484af0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/sidebar/SidebarArticleSectionComponent.vue
// module id = 1428
// module chunks = 1